<template>
  <div class="export-csv">
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="capacitance_readings">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.reports') | firstLetterCapitalize }}
          </div>
          <div class="label-desc">reports desc</div>
        </div>
        <div class="common-title-page" v-loading="loading">
          <div class="title-size mb-30 text-center">
            {{ $t('text.reports') | firstLetterCapitalize }}
          </div>
          <div class="page-content max-w-742">
            <div class="mb-10 dark-font">
              1. {{ $t('text.choose_a_report') }}
            </div>
            <el-select
              v-model="report"
              :placeholder="$t('text.please_select')"
              size="small"
              class="mb-20"
            >
              <el-option
                v-for="item in reports"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
            <div class="mb-10 dark-font">
              2. {{ $t('text.select_date_range') }}
            </div>
            <el-date-picker
              class="mb-20"
              v-model="date"
              type="datetimerange"
              format="dd/MM/yy h:mm:ss A"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="to"
              :start-placeholder="$t('text.start_time')"
              :end-placeholder="$t('text.end_time')"
              :unlink-panels="true"
              size="small"
            >
            </el-date-picker>
            <div class="mb-10 dark-font">
              3. {{ $t('text.select_groups_to_collate') }}
            </div>
            <el-transfer
              class="group-transfer mb-50"
              filterable
              :filter-method="filterMethod"
              :titles="[$t('text.all_groups'), $t('text.group_include')]"
              :filter-placeholder="$t('text.filter_by_group_or_users')"
              v-model="group"
              :data="groups"
            >
            </el-transfer>
            <div class="text-right">
              <el-button
                class="save-btn min-w-80 mini-btn"
                :loading="savingLoading"
                @click="download()"
                >{{ $t('text.export_report') }}</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import $ from 'jquery'
import ApiService from '@/services/ReportApiService.js'
import swal from 'sweetalert'
import { converFile } from '../../utils/utils'
import moment from 'moment'
export default {
  data() {
    return {
      loading: false,
      activeName: 'capacitance_readings',
      screenWidth: window.innerWidth,
      reports: [],
      groups: [],
      report: '',
      date: [
        moment().format('YYYY-MM-DD 00:00:00'),
        moment()
          .add(1, 'days')
          .format('YYYY-MM-DD 00:00:00')
      ],
      group: [],
      savingLoading: false
    }
  },
  mounted: function() {
    window.addEventListener('resize', this.getScreenWidth)
    this.getScreenWidth()
    this.getReportType()
    this.getUserGroups()
  },
  methods: {
    getScreenWidth() {
      this.screenWidth = window.innerWidth
      if (this.screenWidth < 1023) {
        $('.export-csv .el-tabs__header').hide()
      } else {
        $('.export-csv .el-tabs__header').show()
      }
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1
    },
    getUnique(array) {
      let obj = {}
      return array.filter(item => {
        let newItem = item + JSON.stringify(item)
        return obj.hasOwnProperty(newItem) ? false : (obj[newItem] = true)
      })
    },
    getReportType() {
      this.loading = true
      ApiService.GetReportType()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.reports = response.data.data
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    getUserGroups() {
      this.loading = true
      ApiService.GetUserGroups('')
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.groups = []
            let vm = this
            response.data.data.forEach(item => {
              item.Groups.forEach(group => {
                vm.groups.push({
                  label: group.Name,
                  key: group.GroupId
                })
              })
            })
            this.groups = this.getUnique(this.groups)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    getFileName() {
      let vm = this
      let reportType = ''
      this.reports.forEach(item => {
        if (item.Id === vm.report) {
          reportType = item.Name
        }
      })
      return reportType + '_' + this.date[0] + '_' + this.date[1] + '.csv'
    },
    download() {
      if (!this.date.length || !this.report || !this.group) {
        swal({
          icon: 'warning',
          timer: 2000,
          title: 'Please complete the form'
        })
        return false
      }
      this.savingLoading = true
      ApiService.Download(this.date[0], this.date[1], this.report, this.group)
        .then(res => {
          this.savingLoading = false
          converFile(this.getFileName(), res.data)
        })
        .catch(() => {
          this.savingLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
